import React from 'react';
import { Grid, TextField } from '@mui/material';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';

export default function Search({ searchQuery, setSearchQuery }) {

    return (
        <TextField
            sx={{ bgcolor: "white", minWidth: "100%" }}
            size='small'
            id="outlined-search"
            label="Modules by Name"
            placeholder="Search Modules by Name"
            type="search"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            InputProps={{
                endAdornment: <InputAdornment position="end"><SearchIcon /></InputAdornment>,
            }}
        />
    )
}
